import * as Styled from './icons.style';

type Props = {
  width?: number;
  height?: number;
};

export const IconError = ({ width = 24, height = 24 }: Props) => (
  <Styled.IconError width={width} height={height} />
);
